import { Box, Theme, Typography } from '@mui/material';
import { SxProps } from '@mui/system';

import { RootState, useAppSelector } from 'common';
import { selectRecipeCategoryRecipeCount } from 'common/src/store/recipes';
import { DeviceType, useBreakpoint } from '../../../../hooks/useBreakpoint';
import { CategoryRowContainer } from '../../../orders/components/common/product-grid/common/category/CategoryRowContainer';

interface RecipeCategoryGridRowProps {
  categoryName: string;
  categoryId: string;
  rowActionComponent?: React.ReactNode;
  actionComponent?: JSX.Element;
  recomputeRowHeights?: () => void;
  minimal?: boolean;
  isOnMenu?: boolean;
  sx?: SxProps<Theme>;
  isShared?: boolean | undefined;
}

const RecipeCategoryGridRow: React.FC<RecipeCategoryGridRowProps> = (
  props: RecipeCategoryGridRowProps
): JSX.Element => {
  const length = useAppSelector((s: RootState) =>
    selectRecipeCategoryRecipeCount(s, props.categoryId, props.isOnMenu ?? false)
  );
  const { deviceType } = useBreakpoint();
  const isMobile = deviceType === DeviceType.Mobile;
  return (
    <CategoryRowContainer
      sx={{
        ...props.sx,
        display: 'flex',
        gap: 0,
        px: 1,
        height: { xs: 'unset', lg: 24 },
        flexDirection: { xs: 'column', lg: 'row' },
      }}
    >
      <Box sx={{ display: 'flex', width: '100%', gap: 1, height: { xs: 24 } }}>
        {props.rowActionComponent}
        <Box
          sx={{
            display: 'flex',
            flex: { xs: 1.5, lg: 3 },
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Typography
            variant='responsiveParagraphBold'
            noWrap
            sx={{
              color: (theme) => theme.palette.grey[700],
            }}
          >
            {props.categoryName} {!props.minimal && ` (${length})`}
          </Typography>
        </Box>
        {!isMobile && !props.minimal && (
          <Box
            sx={{
              display: 'flex',
              flex: { xs: 1, lg: 3 },
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Typography
              variant='responsiveParagraphBold'
              noWrap
              sx={{
                color: (theme) => theme.palette.grey[700],
              }}
            >
              Tags
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        ></Box>
        {!isMobile && !props.minimal && (
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              flexDirection: 'row',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Typography
              variant='responsiveParagraphBold'
              noWrap
              sx={{
                color: (theme) => theme.palette.grey[700],
              }}
            >
              Servings
            </Typography>
          </Box>
        )}

        <Box sx={{ display: 'flex', alignItems: 'center' }}>{props.actionComponent}</Box>
      </Box>
      {isMobile && !props.minimal && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <Box flex={1}>
            <Typography
              variant='responsiveParagraph'
              noWrap
              sx={{
                color: (theme) => theme.palette.grey[700],
              }}
            >
              Tags
            </Typography>
          </Box>
          <Box flex={1} textAlign='right' sx={{ pr: 5 }}>
            <Typography
              variant='responsiveParagraph'
              noWrap
              sx={{
                color: (theme) => theme.palette.grey[700],
              }}
            >
              Servings
            </Typography>
          </Box>
        </Box>
      )}
    </CategoryRowContainer>
  );
};

export default RecipeCategoryGridRow;
